import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    refreshButton: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      color: palette.white,
    },
    refreshButtonYellow: {
      backgroundColor: palette.navCompanyContextActions,
    },
    refreshButtonGreen: {
      backgroundColor: palette.navAdminActions,
    },
    refreshButtonBlue: {
      backgroundColor: palette.navOperatorActions,
    },
    refreshButtonGray: {
      backgroundColor: palette.navSuperAdminActions,
    },
    buttonGrid: {
      textAlign: 'center',
      justifyContent: 'center',
    },
    buttonIcon: {
      color: palette.blue,
      paddingRight: 3,
      fontSize: 12,
    },
    table: {
      marginTop: 10,
    },
    cardContainer: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 5px',
      [breakpoints.down('sm')]: {
        margin: 5,
      },
    },
    cardContainerSelected: {
      margin: 0,
    },

    pageBody: {
      marginTop: 5,
    },

    sopCardContainer: {
      alignContent: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 10,
      marginBottom: 20,
      height: 110,
      [breakpoints.down(554)]: {
        height: 160,
      },
      [breakpoints.down(323)]: {
        height: 200,
      },
      [breakpoints.down(295)]: {
        height: 265,
      },
    },

    followUpCardContainer: {
      alignContent: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 10,
      height: 100,
      [breakpoints.down(554)]: {
        height: 160,
      },
      [breakpoints.down(323)]: {
        height: 200,
      },
      [breakpoints.down(295)]: {
        height: 265,
      },
    },

    fadein: {
      animation: '$fadein 0.7s forwards',
      opacity: 0,
    },

    '@keyframes fadein': {
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    },
    titleCard: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 14,
      fontWeight: 500,
      zIndex: 2,
      margin: '10px 0px',
    },
    sessionsCardGrid: { marginTop: 25 },
    graphCard: {
      marginTop: 15,
      [breakpoints.up(775.1)]: {
        width: '75%',
      },
      [breakpoints.down(775)]: {
        width: '100%',
      },
    },
    containerGraph: {
      justifyContent: 'center',
      alignItems: 'center',
      [breakpoints.down('md')]: {
        marginLeft: 0,
        justifyContent: 'flex-start',
      },
      [breakpoints.down(775)]: {
        justifyContent: 'center',
      },
      [breakpoints.down(575)]: {
        justifyContent: 'flex-start',
      },
    },
  });

export const overrideCardGraph = (breakpoints): any => ({
  alignItems: 'center',
  display: 'flex',
  [breakpoints.down('md')]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  [breakpoints.down(775)]: {
    flexFlow: 'unset',
    alignItems: 'center',
  },
  [breakpoints.down(575)]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  minHeight: 130,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 180,
    height: 180,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -141,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 180,
    height: 180,
    borderRadius: '50%',
    top: -125,
    right: -100,
    opacity: 0.5,
  },
});

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
